import { observer } from "mobx-react";
import React from "react";
import Icon from "../../components/Icons/Icon";
import AgencyStore from "../../Store/AgencyStore";
import { useNavigate } from "react-router-dom";

const ScheduleNotification = observer(({ newScheduleData }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/care-taker/schedule");
    AgencyStore.setSelectedMenuItem("Schedule");
  };

  return (
    <div className="notificationContainer scheculeNotificationContainer">
      <div className="docIconContainer">
        <Icon iconName="notifications" />
      </div>
      <div className="scheduleNotificationTitle">
        Schedule :
        <span className="scheduleNotificationSubTitle">
          You have {newScheduleData} new schedule assigned .
          <span className="underlineClick" onClick={() => handleViewAll()}>
            View All
          </span>
        </span>
      </div>
    </div>
  );
});

export default React.memo(ScheduleNotification);
